export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST'
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS'
export const GET_COMPANY_FAILED = 'GET_COMPANY_FAILED'

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST'
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS'
export const UPDATE_COMPANY_FAILED = 'UPDATE_COMPANY_FAILED'
